import { ContactsContentHeader } from '@features/contacts/components/ContactsContentHeader';
import { ContactsFormCard } from '@features/contacts/components/ContactsFormCard';
import { AppLayout } from '@features/ui/components/layout/AppLayout';
import { NextPageWithLayout } from '@features/ui/types/NextPageWithLayout';
import staticProps from '@services/staticProps';
import { ReactElement } from 'react';

const Page: NextPageWithLayout = () => (
  <>
    <ContactsContentHeader />
    <ContactsFormCard />
  </>
);

Page.getLayout = function getLayout(page: ReactElement) {
  return <AppLayout>{page}</AppLayout>;
};

export default Page;

export const getStaticProps = staticProps;
